export default __webpack_public_path__ + "assets/products/product-gym.b7ce18022bb887835e6edf1b20803f6f.webp";